/**
 * App-wide feature flags.
 *
 * REQUIRE_LOGIN is the single switch that controls whether logged-out visitors
 * can browse read-only content (feed, posts, companies, events, search):
 *
 *   false (default) → guests may VIEW content but cannot write (comment, like,
 *                     inquire, RSVP, create). Messages and profile editing still
 *                     require an account.
 *   true            → every /app page requires login (original behavior).
 *
 * Flip it by editing the default below, or without touching code by setting the
 * REQUIRE_LOGIN env var at build time (Parcel inlines process.env at build).
 */
export const REQUIRE_LOGIN: boolean =
  ((process.env.REQUIRE_LOGIN ?? "false").toString().trim().toLowerCase() === "true");

/** True when the app allows logged-out browsing. */
export const ALLOW_GUEST_BROWSING = !REQUIRE_LOGIN;
